import { useEffect } from 'react'

import { STORE_NAME } from '~/constants'
import { store } from '~/store'

/**
 * Hook to hydrate the store
 * This particular event is mostly used when the application is opened in multiple tabs
 * @returns
 */
const useHydrateStore = () => {
  useEffect(() => {
    function updateStore(e: StorageEvent) {
      if (e.key === STORE_NAME) {
        store.persist.rehydrate()
      }
    }

    window.addEventListener('storage', updateStore)

    return () => {
      window.removeEventListener('storage', updateStore)
    }
  }, [])
}

export default useHydrateStore
